import { render, staticRenderFns } from "./TabsBaseEmpty.vue?vue&type=template&id=55898ed0&scoped=true&"
import script from "./TabsBaseEmpty.vue?vue&type=script&lang=ts&"
export * from "./TabsBaseEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./TabsBaseEmpty.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabsBaseEmpty.vue?vue&type=style&index=1&id=55898ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55898ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
